import { enUS, es, fr, ptBR } from "date-fns/locale";

export const localeMocks = {
  "pt-BR": ptBR,
  en: enUS,
  fr: fr,
  es: es,
};
